module.exports = __webpack_public_path__ + "components/flag/static/square/ba-ea0550eb9e52a881a238ef7a3de8004a.svg";